import { render } from "./Cookies.vue?vue&type=template&id=49ddd5c9&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=49ddd5c9&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3780999554/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ddd5c9"]])

export default __exports__